import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { WithStyles, withStyles } from "material-ui";
import moment from "moment";

import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    getAccountData,
    getAccount,
    getLastWithdrawalRequest,
} from "../../ducks/account";
import { AccountDto, WithdrawalRequestDto } from "../../util/DTOs/AccountDtos";

const styles = {} as React.CSSProperties;

interface WithdrawalRequestSentPageProps
    extends RouteComponentProps<{ id: number }> {}

interface WithdrawalRequestSentPageReduxProps {
    request: WithdrawalRequestDto;
    accountData: AccountDto;
}

interface WithdrawalRequestSentPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    getAccountData: (id: number) => void;
}

interface WithdrawalRequestSentPageState {}

type WithdrawalRequestSentPageConnectedProps = WithdrawalRequestSentPageProps &
    WithdrawalRequestSentPageReduxProps &
    WithdrawalRequestSentPageDispatchProps;

type WithdrawalRequestSentPagePropsWithStyles = WithdrawalRequestSentPageConnectedProps &
    WithStyles<"">;

class WithdrawalRequestSentPage extends React.Component<
    WithdrawalRequestSentPagePropsWithStyles,
    WithdrawalRequestSentPageState
> {
    componentDidMount() {
        this.props.showLogo(false);
        this.props.setBackButton(`/`);
        this.props.setHeaderValue("");
    }

    componentWillUnmount() {
        this.props.showLogo(true);
        this.props.hideBackButton();
    }

    componentWillReceiveProps(
        nextProps: WithdrawalRequestSentPagePropsWithStyles
    ) {}

    render() {
        const { classes } = this.props;
        const accountNumber = this.props.request.accountNumber;
        const accountData = this.props.accountData;

        return (
            <div className="page-container">
                <h4 className="hypoblue">{`Nostopyyntö lähetetty ${moment().format(
                    "DD.MM.YYYY"
                )} klo ${moment().format("HH.MM")}`}</h4>
                <p className="hypodgrey no-margin">
                    Nosto:
                    <span className="highlight">
                        {" "}
                        {`${this.props.request.amount} €`}
                    </span>{" "}
                    tililtä
                    <span className="highlight">
                        {" "}
                        {accountData.accountName
                            ? `${accountData.accountName} (${accountNumber})`
                            : `${accountNumber}`}
                    </span>{" "}
                    vastatilille.
                </p>
                <p className="hypodgrey no-margin">
                    <span className="highlight">
                        Nosto näkyy vastatilillänne 1-3 pankkipäivän päästä.
                    </span>{" "}
                    Tarvittaessa otamme teihin yhteyttä.
                </p>
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: WithdrawalRequestSentPagePropsWithStyles
): WithdrawalRequestSentPageReduxProps => {
    const req = getLastWithdrawalRequest(state);
    return {
        request: req,
        accountData: getAccountData(state, req.id),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): WithdrawalRequestSentPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getAccountData: (id: number) => {
            dispatch(getAccount(id));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WithdrawalRequestSentPage));



// WEBPACK FOOTER //
// ./src/views/account/WithdrawalRequestSentPage.tsx